export class PaginationsModel
{
 recordsPerPage:number;
 currentPage:number;
 totalRecords:number;
 isServerSide:boolean;
 hideGoToPage?:boolean;
}
